<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <vs-tab
      icon-pack="feather"
      icon="icon-info"
      :label="!isSmallerScreen ? 'Compnany Info' : ''"
    >
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <InfoForm />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-lock"
      :label="!isSmallerScreen ? 'Change Password' : ''"
    >
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <PasswordForm />
      </div>
    </vs-tab>
  </vs-tabs>
</template>
<script>
import PasswordForm from "./components/PasswordForm.vue";
import InfoForm from "./components/InfoForm.vue";

export default {
  components: {
    PasswordForm,
    InfoForm,
  },
  data() {
    return {};
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
